export const styles = {
  button: {
    padding: '0 0.4rem',
  },
};
